import {AfterViewInit, Component, ComponentRef, inject, OnDestroy, ViewChild, ViewContainerRef} from '@angular/core';
import {ContestLessonsComponent} from './contest-lessons.component';
import {
    CONTEST_LESSONS_COMPONENT,
    ContestLessonsComponentContract,
} from './contest-lessons-component.contract';

@Component({
    selector: 'app-contest-lessons-host',
    template: '<ng-template #host></ng-template>',
    standalone: false,
})
export class ContestLessonsHostComponent implements AfterViewInit, OnDestroy {
    @ViewChild('host', {read: ViewContainerRef, static: true})
    private host: ViewContainerRef;

    private componentRef: ComponentRef<ContestLessonsComponentContract>;
    private configuredComponent = inject(CONTEST_LESSONS_COMPONENT, {optional: true});

    public ngAfterViewInit(): void {
        this.componentRef = this.host.createComponent(
            this.configuredComponent ?? ContestLessonsComponent
        );
    }

    public ngOnDestroy(): void {
        this.componentRef?.destroy();
    }
}
